<a
  *ngIf="eventCard"
  floAnalytics
  [analyticsProperties]="eventCard.action.analytics"
  class="thumbnail-event-card"
  (click)="handleEventClicked(eventCard)"
  data-test="thumbnail-event-card"
  [ngClass]="{ disabled: isGeoBlocked }"
>
  <div class="thumbnail-event-card__image image h-auto p-0">
    <flo-image-thumbnail
      [imageUrl]="eventCard.previewImage?.url"
      [altText]="eventCard.previewImage?.altText || eventCard.title"
      imageSize="720"
      mobileSize="720"
    >
    </flo-image-thumbnail>
  </div>

  <!-- overlays -->
  <div class="overlay rounded">
    <div class="overlay__content">
      
      <ng-container *ngIf="eventCard.label1Parts?.status === 'LIVE'">
        <flo-svg-icon data-test="badge-live" icon="badge-live" width="26px" class="badge-live svg-vertical-align-middle"></flo-svg-icon>
      </ng-container>
      <ng-container *ngIf="!!formattedStartDate">
        <span data-test="badge-date"  class="formated-start-date">{{ formattedStartDate }}</span>
      </ng-container>

      <div *ngIf="!!eventCard.title" class="thumbnail-event-card__event-title text-line-clamp-2">
        {{ eventCard.title }}
      </div>
    </div>

    <div *ngIf="isGeoBlocked" class="geoblock-label rounded px-3 py-1" data-test="geoblock-label">
      <span>Not available in your location</span>
    </div>
  </div>
  
  <div class="hover-cta-overlay rounded" *ngIf="!isGeoBlocked">
    <h2 class="h2">Watch Now</h2>
    <button class="btn btn-sm btn-primary">Start Streaming</button>
  </div>
</a>
